const EmailTemplateKeys = Object.freeze({
  WELCOME: 'welcome',
  SET_PASSWORD: 'setPassword',
  RESET_PASSWORD: 'resetPassword',
  PASSWORD_RESET_SUCCESS: 'passwordResetSuccess',
  API_TOKEN_CREATED: 'apiTokenCreated',
  API_TOKEN_REVOKED: 'apiTokenRevoked',
  API_TOKEN_ALL_REVOKED: 'apiTokenAllRevoked',
  API_TOKEN_DELETED: 'apiTokenDeleted',
  SIGNUP_VERIFY: 'signupVerify',
  MFA_OTP: 'mfaOtp',
});

const EmailTemplateValues = Object.freeze({
  SUBJECT_WELCOME: 'Welcome to Our Platform',
  SUBJECT_SET_PASSWORD: 'New User Account Created',
  SUBJECT_RESET_PASSWORD: 'Reset Your QA PATH Password',
  SUBJECT_PASSWORD_RESET_SUCCESS: 'Your QA PATH Password Has Been Reset Successfully',
  SUBJECT_API_TOKEN_CREATED: 'New API Token Created',
  SUBJECT_API_TOKEN_REVOKED: 'API Token Revoked',
  SUBJECT_API_TOKEN_ALL_REVOKED: 'All API Tokens Revoked',
  SUBJECT_API_TOKEN_DELETED: 'API Token Deleted',
  SUBJECT_SIGNUP_VERIFY: 'Verify your email to sign up',
  PRODUCT_NAME: 'QA PATH',
  COMPANY_NAME: 'QA PATH',
  COPYRIGHT: '© 2025 QA PATH. All rights reserved.',
  SUBJECT_MFA_OTP: 'Your QA PATH login verification code',
});

/** IDs stored in email-service (DynamoDB); must match POST /templates payloads. */
const EmailServiceTemplateIds = Object.freeze({
  WELCOME: 'welcome',
  SET_PASSWORD: 'set-password',
  RESET_PASSWORD: 'reset-password',
  PASSWORD_RESET_SUCCESS: 'password-reset-success',
  API_TOKEN_CREATED: 'api-token-created',
  API_TOKEN_REVOKED: 'api-token-revoked',
  API_TOKEN_ALL_REVOKED: 'api-token-all-revoked',
  SIGNUP_VERIFY: 'signup-verify',
  MFA_OTP: 'mfa-otp',
});

module.exports = {
  EmailTemplateKeys,
  EmailTemplateValues,
  EmailServiceTemplateIds,
}; 